module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/icon-tick.fff11068c6edf07880f65825374a3604.svg";